import { atom } from 'recoil'
import { ILibraryDocument } from './libraryDocuments.types'

interface ILibraryDocumentsState {
  items: ILibraryDocument[]
  loaded: boolean
}

const libraryDocumentsAtom = atom<ILibraryDocumentsState>({
  key: 'libraryDocuments',
  default: {
    items: [],
    loaded: false,
  },
})

export default libraryDocumentsAtom
